import LocationSearchActions from '../../../actions/LocationSearchActions'
import { FLIGHT_PRODUCT_TYPE } from '../../../constants/Constants'

export function handleTypeahead (currentQuery, isMobile = false, isParsingFlightLocation = true) {
  return LocationSearchActions.queryLocations({
    query: currentQuery,
    type: FLIGHT_PRODUCT_TYPE,
    cities: 0,
    airports: 9,
    pois: 0,
    hotels: 0,
    setOrigin: false,
    isParsingFlightLocation,
    isUsingCityCodeDisplay: isMobile
  })
}
